export default __webpack_public_path__ + "static/media/billion-smiles-02.74b6064b.png";